import { DateTime } from 'luxon';

export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.onerror = error => reject(error);
    });
};

export function prependBase64String(base64: string, format: string) {
    if (base64.includes('data:') && base64.includes('base64')) return base64;

    return `data:${format};base64,${base64}`;
}

export function getExpiryYearsForDocument() {
    const now = DateTime.now().get('year');
    const max = now + 21;
    const yearOptions = [];
    for (let i = now; i < max; i++) {
        yearOptions.push({
            label: i.toString(),
            value: i.toString()
        });
    }
    return yearOptions;
}
